import React from 'react'
import type { StyleClasses } from '../../styles'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'
import type { FormLabelProps as MuiFormLabelProps } from '@material-ui/core/FormLabel'
import MuiFormLabel from '@material-ui/core/FormLabel'

const useStyles = makeStyles<Theme, FormLabelProps>((theme) => ({
  root: {
    ...theme.typography.overline,
    color: theme.palette.common.black,
    border: 'none'
  }
}))

export interface FormLabelProps extends MuiFormLabelProps {
  classes?: StyleClasses<typeof useStyles>
}

function FormLabel(props: FormLabelProps) {
  const classes = useStyles(props)
  return <MuiFormLabel {...props} classes={classes} />
}

export default FormLabel
